import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../../../context/app/context";
import ScaleContext from "../../../context/scale/context";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import EndPoints from "../../../services/end-points";
import { IStore } from "../../../models/store/response";
import { createNamlieahStoreFilter } from "../../../utils/helpers/store-filters";

interface IProps {}

const ScaleFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(ScaleContext);
  const { direction } = useContext(AppContext);

  const [stores, setStores] = useState<IStore[]>([]);
  const [storesLoading, setStoresLoading] = useState<boolean>(false);

  const activeOptions = [
    { label: t("active"), value: true },
    { label: t("inactive"), value: false },
  ];

  useEffect(() => {
    const getStores = async () => {
      try {
        setStoresLoading(true);
        const { data } = await EndPoints.store.getAllStores({
          light: true,
          perPage: -1,
          filters: [createNamlieahStoreFilter()],
        });
        setStores(data.data);
      } catch (error) {
      } finally {
        setStoresLoading(false);
      }
    };
    getStores();
  }, [direction]);

  return (
    <Form
      formId="scale-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: query?.keyword,
          filters: [
            data?.storeId
              ? {
                  name: "storeId",
                  value: data.storeId,
                  operation: "eq",
                }
              : undefined,
            data?.isActive !== undefined && data?.isActive !== null
              ? {
                  name: "isActive",
                  value: data.isActive,
                  operation: "eq",
                }
              : undefined,
          ].filter((f) => f),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="storeId"
            label={`${t("store")}`}
            width="large"
            input={{
              type: "select",
              loading: storesLoading,
              allowSearch: true,
              options: stores.map((store: IStore) => ({
                label: store?.name as string,
                value: store?.id as number,
              })),
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="isActive"
            label={`${t("is_active")}`}
            width="large"
            input={{
              type: "select",
              options: activeOptions,
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default ScaleFilter;
